import styled from 'styled-components';

import { space, media, rems } from '../../ui/helpers';
import { colors } from '../../ui/design-tokens';
import fonts from '../../ui/fonts';

const Forest = styled.div<{
  bg?: string;
}>`
  background: ${({ bg }) => `url(${bg}) 50% repeat-x`};
  height: ${rems(141)};
  margin: ${space(6)} 0 0;

  ${media.min('medium')`
    margin: ${space(8)} 0 0;
  `}
`;

const FooterStyled = styled.footer`
  ${fonts.bodySM};

  background: ${colors.neutral[900]};
  a,
  a:hover,
  a:link,
  a:active,
  a:focus {
    font-weight: 400;
    text-decoration: none !important;
  }
`;

const WMap = styled.div`
  ${media.min('medium')`
    padding: 0 ${space(3)};
    margin: auto;
  `}

  ${media.between('medium', 1330)`
    padding: 0 ${space(3)};
  `}

  ${media.between(1330, 'xxlarge')`
    padding: 0;
  `};

  ${media.min('xxlarge')`
    padding: 0;
  `}
`;

const RRSS = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${space(6)} ${space(2)};

  .title {
    margin: 0 0 ${space(3)};
    color: ${colors.neutral[400]};
  }

  ${media.min('medium')`
    display: flex;
    justify-content: flex-end;
    text-align: left;
    flex-direction: row;
    padding-left: inherit;
    padding-right: inherit;

    .title {
      margin: 0 ${space(2)} 0 0;
    }
  `};
`;

const Foot = styled.div`
  background: ${colors.neutral[800]};
  padding: 0;

  .wrapper {
    display: flex;
    flex-direction: column-reverse;
    padding: ${space(5)} 0 ${space(12)} 0;
    ${media.min('medium')`
      padding: ${space(1)};
      align-items: center;
      flex-direction: row-reverse;
      justify-content: space-between;
    `};
  }

  ${media.min('medium')`
    padding: ${space(3)} 0  ${space(3)} 0;
  `};
  ${media.max('xlarge')`
    padding: ${space(3)};
  `};
`;

const Language = styled.div`
  display: flex;
  margin: ${space(3)} 0 0 0;
  justify-content: center;

  a {
    text-transform: uppercase;
    color: ${colors.neutral[100]};
    &.active {
      color: ${colors.neutral[100]};
    }
  }
  ${media.min('medium')`
    margin-top: 0;
    justify-content: left;
  `};
`;

const Links = styled.div`
  .copyright {
    ${fonts.bodySM};
    color: ${colors.neutral[400]};
    margin: 0 0 ${space(2)};
    text-align: center;
    ${media.min('medium')`
      margin: 0 ${space(4)} 0 0;
    `};
  }

  .menu-list {
    align-items: center;
    display: flex;
    flex-direction: column;

    ${media.min('medium')`
      flex-direction: row;
    `};
  }

  .menu-item {
    &:not(:last-child) {
      margin: 0 0 ${space(3)} 0;

      ${media.min('medium')`
        margin: 0 ${space(3)} 0 0;
      `};
    }

    a {
      color: ${colors.neutral[100]};

      &:hover,
      &:active {
        color: ${colors.neutral[100]};
      }
    }
  }

  ${media.min('medium')`
    align-items: center;
    display: flex;
  `};
`;

const CurrentCountry = styled.span`
  align-items: center;
  color: ${colors.neutral[100]};
  display: inline-flex;
  vertical-align: middle;

  svg {
    display: block;
    height: 14px;
    margin: 0 ${space()} 0 0;
    width: 14px;

    path {
      fill: currentColor;
    }
  }
`;

export { Forest, FooterStyled, Foot, Language, Links, RRSS, WMap, CurrentCountry };
